import { FormCard } from '@qbe/ads-blocks-forms';
import { Button, Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

import feefoLogo from '~/assets/images/feefo_logo-1.svg';

import { config } from '../../config';
import { useAppContent, useExtraInfo, useQuote } from '../../hooks';
import { feefoSmartLink } from './feefoSmartLink';
import { StarsLink } from './StarsLink';

export const FeefoPanel = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.confirmation' });
  const { email } = useExtraInfo();
  const { policyNumber, premiums } = useQuote();
  const link = feefoSmartLink({
    endpoint: config.endpoints.feefo,
    email: email ?? '',
    name: 'Valued Customer',
    orderRef: policyNumber ?? '',
    products: [
      {
        ref: 'Policy',
        description: 'Small Business Insurance',
        amount:
          premiums?.policy?.policyPremium?.transactionPremium?.totalPremium?.toFixed(2) ?? '0',
        link: `${config.origin}${config.baseUrl}`,
        tag: 'insurance:Small Business Insurance',
      },
    ],
  });
  return (
    <FormCard variant="sectionTitle" title={getTextContent('feedbackfeefo.text.title')}>
      <Typography align="center">{getTextContent('feedbackfeefo.text.description')}</Typography>
      <Spacer size="md" />
      <img style={{ width: '7rem ' }} src={feefoLogo} alt="Feefo" />
      <Spacer size="sm" />
      <StarsLink link={link} />
      <Spacer size="md" />
      <Button
        target="_blank"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        rel={'noopener noreferrer'}
        component="a"
        data-track={getTextContent('buttons.rateUsNow')}
        label={getTextContent('buttons.rateUsNow')}
      />
    </FormCard>
  );
};
